<template>

  <Modal v-model="formDialog" :mask-closable="false" width="550" draggable @on-cancel="closeDialog">
    <div slot="header"><strong>Cancel Order</strong></div>
    <div slot="close"><Icon size="20" style="padding: 4px;color: #999" type="md-close" @click="closeDialog"/></div>
    <div>
      <div style="font-size: 16px;margin: 10px 10px 16px 10px">#{{order&&order.orderNumber}}</div>
      <Form :model="form" :rules="ruleForm" ref="form" :label-width="140">
        <FormItem prop="cancellationReason" label="Cancel Reason">
          <Select v-model="form.cancellationReason" filterable>
            <Option v-for="(reason, index) in Constants.cancellationReasonOptions"
                    :key="index" :label="reason" :value="reason"/>
          </Select>
        </FormItem>

        <FormItem prop="cancelNote" label="Cancel Note">
          <Input type="textarea" v-model="form.cancelNote"/>
        </FormItem>
      </Form>
    </div>
    <div slot="footer">
      <Button type="primary" style="font-weight: bolder" @click="handleSubmit" :loading="loading">
        <span v-if="!loading">SAVE</span> <span v-else>Loading...</span>
      </Button>
      <Button style="background: #999999; color: white;font-weight: bolder" @click="closeDialog">CANCEL</Button>
    </div>
  </Modal>

</template>

<script>
import {Constants} from "../../Constants/Constant";
import ValidationRules from "../../Constants/ValidationRules";
import {WHILE_CANCEL_ORDER} from "../../graphql/mutations/orders";
import moment from 'moment';

export default {
    name: "CancelOrderPopup",
    props: ['formDialog', 'order'],
    data(){
      return{
        Constants: Constants,
        userObj: JSON.parse(localStorage.getItem('tatkalorri')).userObj,
        form: {
          cancellationReason: '',
          cancelNote: ''
        },
        ruleForm:{
          cancellationReason: ValidationRules.textField('Cancel Reason'),
          cancelNote: ValidationRules.textField('Cancel Note'),
        },
        loading: false
      }
    },
    methods:{
      handleSubmit(){
        this.loading = true
        this.$refs['form'].validate((valid) => {
          if (valid) this.cancelOrder();
          else this.loading = false
        })
      },
      async cancelOrder(){
        this.order.materials.boxes = 'Empty Return Charge'
        let response = await this.$apollo.mutate({
          mutation: WHILE_CANCEL_ORDER,
          variables: {
            orderId: this.order.id,
            order: {
              internalstatus: Constants.internalStatus.readyForFinalDelivery,
              lastStageUpdatedOn : moment().format(),
              lastStageUpdatedBy : this.userObj.user.id,
              materials: this.order.materials
            },
            orderDetailId: this.order.orderDetails.id,
            orderDetail: {
              cancellationReason: this.form.cancellationReason
            },
            note: {
              note: this.form.cancelNote, type: 'CANCEL', orderId: this.order.id,
              createdBy: this.userObj.user.id, lastUpdatedBy: this.userObj.user.id
            }
          }
        })
        if(response.data){
          this.$Message.success('Order Canceled successfully!');
          this.loading = false
          this.closeDialog();
          this.$emit('closeMainModal')
        }
      },
      closeDialog(){
        this.$refs['form'].resetFields()
        this.$emit('update:formDialog', false)
      }
    }
}
</script>

<style scoped>
  /deep/ .ivu-select-item{
    padding: 7px 14px !important;
  }
</style>
